import React, { useState } from "react";
import { CheckIcon, CopyIcon, DownloadIcon } from "lucide-react";
import { krusherCardHtml } from "../data/fourthwallSnippet";
import { brandCards } from "../data/brandCards";
export function FourthwallSnippet() {
  const [copied, setCopied] = useState<"idle" | "done" | "error">("idle");
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(krusherCardHtml);
      setCopied("done");
      window.setTimeout(() => setCopied("idle"), 2000);
    } catch {
      setCopied("error");
    }
  };
  return <div className="mx-auto max-w-6xl px-5 py-12 md:py-16" data-id="element-96" data-mp="3beety2zivi0p">
      <header className="max-w-2xl" data-id="element-97" data-mp="2wgwang5m5x0n">
        <h1 className="font-display text-5xl font-bold uppercase leading-none tracking-tight text-ink md:text-6xl" data-id="element-98" data-mp="2whxm3lqjkliw">Fourthwall card</h1>
        <p className="mt-4 text-lg text-muted" data-id="element-99" data-mp="uopylp0ryxlx">
          In Fourthwall, go to <span className="font-medium text-ink" data-id="element-100" data-mp="umdf37fdcf6r">Site design → Homepage → Add section → Custom HTML</span>, paste the code, and place it under Featured Brands. If you publish this site somewhere else, change the link from krushers.sklunx.com to that address.
        </p>
      </header>

      <section aria-labelledby="cards-h" className="mt-10" data-id="element-101" data-mp="35fdk9w3bjd3d">
        <h2 id="cards-h" className="font-display text-3xl font-bold uppercase tracking-tight text-ink" data-id="element-102" data-mp="3k4t9h7n7bagy">Featured Brands card</h2>
        <p className="mt-2 max-w-2xl text-muted" data-id="element-103" data-mp="3f5ysmb8snvzh">
          Download one of these and upload it as the Sklunx Krushers image in your Featured Brands row. It's the same poster style as your other brand cards.
        </p>
        <ul className="mt-6 grid gap-8 sm:grid-cols-2 lg:max-w-4xl" data-id="element-104" data-mp="2mivx7rzf01dg">
          {brandCards.map(c => <li key={c.id} className="flex flex-col gap-3" data-id="element-105" data-mp="30e7pztu0fhrq">
              <img src={c.src} alt={`Sklunx Krushers brand card, ${c.name.toLowerCase()}`} className="aspect-[4/5] w-full rounded-xl object-cover" data-id="element-106" data-mp="2we5zmgtq6arr" />
              <div className="flex items-start justify-between gap-4" data-id="element-107" data-mp="boqadqa5mu48">
                <div data-id="element-108" data-mp="bogmc88o6x16">
                  <h3 className="font-semibold text-ink" data-id="element-109" data-mp="34j70wviatd1z">{c.name}</h3>
                  <p className="text-sm text-muted" data-id="element-110" data-mp="34iynn2i9k5q9">{c.use}</p>
                </div>
                <a href={c.src} download={`sklunx-krushers-${c.id}.jpg`} target="_blank" rel="noreferrer" className="inline-flex shrink-0 items-center gap-2 rounded-full border border-ink px-4 py-2 text-sm font-medium text-ink transition-colors duration-150 hover:bg-mist" data-id="element-111" data-mp="39h037dghdmwz">
                  <DownloadIcon className="h-4 w-4" data-id="element-112" data-mp="2qsv6ur25l487" /> Download
                </a>
              </div>
            </li>)}
        </ul>
      </section>

      <h2 className="mt-16 font-display text-3xl font-bold uppercase tracking-tight text-ink" data-id="element-113" data-mp="2urkjuija4jrb">Wide banner (optional)</h2>
      <p className="mt-2 max-w-2xl text-muted" data-id="element-114" data-mp="232r3mksvn6hq">Use this if you want a full-width Krushers section on the home page instead of just a card.</p>

      <section aria-labelledby="preview-h" className="mt-6" data-id="element-115" data-mp="2729ppjwfpnm5">
        <h2 id="preview-h" className="text-sm font-semibold text-muted" data-id="element-116" data-mp="1zktlt2mt233i">Preview</h2>
        <div className="mt-3 rounded-2xl border border-line bg-paper" dangerouslySetInnerHTML={{
        __html: krusherCardHtml
      }} data-id="element-117" data-mp="1ulgplra1njo9" />
      </section>

      <section aria-labelledby="code-h" className="mt-10" data-id="element-118" data-mp="1qiakimyo3yjd">
        <div className="flex items-center justify-between gap-4" data-id="element-119" data-mp="1lksk5kypurmz">
          <h2 id="code-h" className="text-sm font-semibold text-muted" data-id="element-120" data-mp="1lmmuy6g9x3dc">Code</h2>
          <button type="button" onClick={copy} className="inline-flex items-center gap-2 rounded-full bg-ink px-4 py-2 text-sm font-medium text-paper transition-colors duration-150 hover:bg-ink/85" data-id="element-121" data-mp="1gn0hbvwj9l40">
            {copied === "done" ? <CheckIcon className="h-4 w-4" data-id="element-122" data-mp="12uu4ojsl9w9b" /> : <CopyIcon className="h-4 w-4" data-id="element-123" data-mp="12vvrfliyw76v" />}
            {copied === "done" ? "Copied" : "Copy HTML"}
          </button>
        </div>
        {copied === "error" && <p role="alert" className="mt-2 text-sm text-red-700" data-id="element-124" data-mp="svbnuc7z6qlh">Couldn't copy automatically. Select the code below and copy it manually.</p>}
        <pre className="mt-3 max-h-96 overflow-auto rounded-2xl bg-ink p-5 text-xs leading-relaxed text-paper" data-id="element-125" data-mp="2symjszdgt00x">
          <code data-id="element-126" data-mp="2xza8vfi4v6si">{krusherCardHtml}</code>
        </pre>
      </section>
    </div>;
}